import { SORT_DIRECTION } from './constants';

export default {
	sortColumn: undefined,
	sortDirection: SORT_DIRECTION.NULL
};
